import { defineMessages } from 'react-intl';

/** design: trial-upsell b5 (clean copies after the payment). */
export const cleanCopiesMessages = defineMessages({
  eyebrowPlan: { id: 'app.sml.upsell.watermark.copies.eyebrow', defaultMessage: 'You are on {plan}' },
  runningTitle: {
    id: 'app.sml.upsell.watermark.copies.running.title',
    defaultMessage: 'We remove the watermark from your {count, plural, one {# file} other {# files}} now.',
  },
  runningBody: {
    id: 'app.sml.upsell.watermark.copies.running.body',
    defaultMessage: 'You can close this window. We send an email when all files are clean.',
  },
  progressLabel: { id: 'app.sml.upsell.watermark.copies.progress', defaultMessage: 'Clean copies' },
  progressValue: { id: 'app.sml.upsell.watermark.copies.progress.value', defaultMessage: '{done} / {total}' },
  stateClean: { id: 'app.sml.upsell.watermark.copies.state.clean', defaultMessage: 'Clean' },
  stateMaking: { id: 'app.sml.upsell.watermark.copies.state.making', defaultMessage: 'Making {percent}%' },
  stateQueued: { id: 'app.sml.upsell.watermark.copies.state.queued', defaultMessage: 'Making' },
  statePro: { id: 'app.sml.upsell.watermark.copies.state.pro', defaultMessage: 'Pro' },
  stateFailed: { id: 'app.sml.upsell.watermark.copies.state.failed', defaultMessage: 'Failed' },
  size: { id: 'app.sml.upsell.watermark.copies.size', defaultMessage: '{width} × {height}' },
  needsProNote: {
    id: 'app.sml.upsell.watermark.copies.note.needsPro',
    defaultMessage: 'Needs Pro. Stays a preview.',
  },
  failedNote: {
    id: 'app.sml.upsell.watermark.copies.note.failed',
    defaultMessage: 'We did not make this copy. Make the file again in the Studio.',
  },
  openSong: { id: 'app.sml.upsell.watermark.copies.openSong', defaultMessage: 'Open {song}' },
  openRelease: { id: 'app.sml.upsell.watermark.copies.openRelease', defaultMessage: 'Open the release' },
  preparingTitle: {
    id: 'app.sml.upsell.watermark.copies.preparing.title',
    defaultMessage: 'We prepare your clean copies',
  },
  preparingBody: {
    id: 'app.sml.upsell.watermark.copies.preparing.body',
    defaultMessage:
      '{count, plural, one {Your file comes again with no watermark.} other {Your # files come again with no watermark.}} This starts in a moment.',
  },
  postsRunning: {
    id: 'app.sml.upsell.watermark.copies.posts.running',
    defaultMessage: '{count, plural, one {# post gets} other {# posts get}} the clean file.',
  },
  doneEyebrow: { id: 'app.sml.upsell.watermark.copies.done.eyebrow', defaultMessage: 'Done' },
  doneTitle: {
    id: 'app.sml.upsell.watermark.copies.done.title',
    defaultMessage: '{count, plural, one {Your file is clean.} other {All # files are clean.}}',
  },
  doneTitlePart: {
    id: 'app.sml.upsell.watermark.copies.done.titlePart',
    defaultMessage: '{done} of {total} files are clean.',
  },
  doneBody: { id: 'app.sml.upsell.watermark.copies.done.body', defaultMessage: 'Full size, with only your name.' },
  doneBodyPosts: {
    id: 'app.sml.upsell.watermark.copies.done.bodyPosts',
    defaultMessage: '{count, plural, one {Your # post uses the clean file.} other {Your # posts use the clean files.}}',
  },
  downloadKit: { id: 'app.sml.upsell.watermark.copies.downloadKit', defaultMessage: 'Download the kit' },
  postThem: { id: 'app.sml.upsell.watermark.copies.postThem', defaultMessage: 'Post them' },
  coverLine: {
    id: 'app.sml.upsell.watermark.copies.cover',
    defaultMessage: 'Open the cover editor to export your cover with no watermark.',
  },
  navLabel: { id: 'app.sml.upsell.watermark.copies.nav', defaultMessage: 'Clean copies {done} / {total}' },
});
